import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import auth from './modules/auth'
import map from './modules/map'
import layer from './modules/layer'
import project from './modules/project'
import legend from './modules/legend'
import draw from './modules/draw'
import style from './modules/style'

Vue.use(Vuex)

const state = {}
const actions = ({})
const mutations = ({})
const getters = ({})

const modules = {
  app: app,
  auth: auth,
  layer: layer,
  legend: legend,
  map: map,
  draw: draw,
  style: style,
  project: project
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules
})

/*

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    statusLayer: {
      newLayer: false,
      applyFilter: false
    },
    newLayer: false,
    currentLayer: null,
    currentLegend: {}, // TODO INSERIR TODA A LEGENDA AQUI
    allLegend: [],
    geoPopLevels: [],
    editLegend: false,
    oldLayer: {},
    layerList: []
  },
  mutations: { // Syncronous
    setStatusLayer (state, payload) {
      state.statusLayer = payload
    },
    setCurrentLegend (state, payload) {
      state.currentLegend = payload
    },
    setNewLayer (state, payload) {
      state.newLayer = payload
    },
    setCurrentLayer (state, payload) {
      state.currentLayer = payload
    },
    setAllLegend (state, payload) {
      state.allLegend = payload
    },
    IncrementLegend (state, payload) {
      if (!state.allLegend.includes(payload)) {
        state.allLegend.push(payload)
      }
    },
    DecrementLegend (state, payload) {
      state.allLegend = state.allLegend.filter((legend) => {
        if (legend !== payload) return legend
      })
    },
    setEditLegend (state, payload) {
      state.editLegend = payload
    },
    setGeoPopLevels (state, payload) {
      state.geoPopLevels = payload
    },
    setLayerList (state, payload) {
      state.layerList = payload
    },
    updateLayerStyle (state, payload) {
      const item = state.layerList.find(item => item.id === payload.id)
      const layer = item.object.layer
      const dataVis = layer.jbData.config.datavis
      dataVis.style = payload.style
    }
  },
  actions: { // Asyncronous
    setCurrentLayer (state, payload) {
      state.commit('currentLayer', payload)
    }
  },
  modules: {},
  getters: { // Getters
    getStatusLayer (state) {
      return state.statusLayer
    },
    getCurrentLegend (state) {
      return state.currentLegend
    },
    getNewlayer (state) {
      return state.newLayer
    },
    getCurrentLayer (state) {
      return state.currentLayer
    },
    getAllLegend (state) {
      return state.allLegend
    },
    getEditLegend (state) {
      return state.editLegend
    },
    getGeoPopLevels (state) {
      return state.geoPopLevels
    },
    getLayerList (state) {
      return state.layerList
    },
    getLayerStyle (state, id) {
      const item = state.layerList.find(item => item.id === id)
      const layer = item.object.layer
      const dataVis = layer.jbData.config.datavis
      return dataVis.style
    }
  }
})
*/
